import { useCallback, useEffect } from "react";
import { taxonomyList } from "../services/taxonomyService";
import { toast } from "react-toastify";

export const useLoadTaxonomyList = () => {
  const loadTaxonomyList = useCallback(async ({ type, keyword = "" }, setList) => {
    // console.log(keyword, "keywordkeywordkeyword");
    try {
      const payload = {
        type,
        ...(keyword && { keyword }),
      };

      const res = await taxonomyList({
        ...payload,
        sortQuery: "-createdAt",
      });
      if (res?.docs?.success && res?.docs?.status === 200) {
        const data =
          res?.docs?.data &&
          Array?.isArray(res?.docs?.data) &&
          res?.docs?.data?.length > 0 &&
          res?.docs?.data?.map((item) => ({
            createdAt: item?.createdAt,
            slug: item?.slug,
            status: item?.status,
            title: item?.title,
            type: item?.type,
            uid: item?.uid,
            _id: item?._id,
          }));
        setList({ data: data || [], loading: false });
      } else {
        throw new Error(res?.message || "Failed to fetch taxonomy list.");
      }
    } catch (error) {
      console.error("Error loading taxonomy list:", error);
      toast.error(error.message || "Something went wrong while loading taxonomy.");
      setList({ data: [], loading: false });
    }
  }, []);

  return { loadTaxonomyList };
};
